/* eslint-disable max-lines-per-function */

import { FieldBase } from '@/domain/mitarbeiter/features/anlageassistent/components/form/fieldComponents/FieldBase';
import { InfoButton } from '@/domain/mitarbeiter/features/anlageassistent/components/InfoButton';
import { FixgehaltFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/FixgehaltFields/FixgehaltFields';
import { StundenFields } from '@/domain/mitarbeiter/features/anlageassistent/content/Bezahlung/StundenFields/StundenFields';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import {
  bezahlungsartAuswahl,
  BezahlungsartAuswahl,
} from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/bezahlungsartAuswahl';
import { Body, Heading, RadioGroup, RadioGroupItem, Spinner } from '@e2n/ui/v2';
import { faClock, faMoneyBill } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Suspense } from 'react';
import { useTranslation } from 'react-i18next';

export function Bezahlungsart() {
  const { ctx } = useAnlageassistentContext();
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-3">
        <div className="flex gap-1 items-center">
          <Heading>{ctx.getCurrentSubStep()?.title}</Heading>
          <InfoButton>
            <Body>
              {t(
                'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.info',
              )}
            </Body>
          </InfoButton>
        </div>
        <Body>
          {t(
            'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.description',
          )}
        </Body>
      </div>

      <form.AppField
        name="bezahlung.bezahlungsart.art"
        listeners={{
          onChange: ({ value }) => {
            ctx.resetDependentFields('bezahlung.bezahlungsart.art');
            if (value === 'fixgehalt') {
              form.setFieldValue(
                'bezahlung.arbeitszeitkonto.art',
                'gehaltsempfaenger',
              );
            } else {
              form.setFieldValue(
                'bezahlung.arbeitszeitkonto.art',
                'stundenloehner',
              );
            }
          },
        }}>
        {(field) => {
          return (
            <FieldBase>
              <RadioGroup
                className="flex flex-row"
                value={field.state.value}
                onValueChange={(val) =>
                  field.handleChange(val as BezahlungsartAuswahl)
                }>
                <RadioGroupItem
                  variant="card"
                  value={bezahlungsartAuswahl.fixgehalt}
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.fixgehalt',
                  )}
                  icon={<FontAwesomeIcon icon={faMoneyBill} />}
                  className="w-full"
                />
                <RadioGroupItem
                  variant="card"
                  value={bezahlungsartAuswahl.stunden}
                  layout="horizontal"
                  label={t(
                    'domain.mitarbeiter.create.steps.bezahlung.bezahlungsart.form.art.options.stunden',
                  )}
                  icon={<FontAwesomeIcon icon={faClock} />}
                  className="w-full"
                />
              </RadioGroup>
            </FieldBase>
          );
        }}
      </form.AppField>

      <form.Subscribe
        selector={(state) => ({
          bezahlungsart: state.values.bezahlung.bezahlungsart,
        })}>
        {({ bezahlungsart }) =>
          bezahlungsart.art && (
            <Suspense
              fallback={
                <div className="flex items-center justify-center">
                  <Spinner variant="light-grey" />
                </div>
              }>
              {bezahlungsart.art === 'fixgehalt' && <FixgehaltFields />}
              {bezahlungsart.art === 'stunden' && <StundenFields />}
            </Suspense>
          )
        }
      </form.Subscribe>
    </div>
  );
}
